var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1668 4.16667H5.8335C5.61248 4.16667 5.40052 4.25446 5.24424 4.41074C5.08796 4.56702 5.00016 4.77899 5.00016 5V15C5.00016 15.221 5.08796 15.433 5.24424 15.5893C5.40052 15.7455 5.61248 15.8333 5.8335 15.8333H14.1668C14.3878 15.8333 14.5998 15.7455 14.7561 15.5893C14.9124 15.433 15.0002 15.221 15.0002 15V5C15.0002 4.77899 14.9124 4.56702 14.7561 4.41074C14.5998 4.25446 14.3878 4.16667 14.1668 4.16667ZM5.8335 2.5C5.17045 2.5 4.53457 2.76339 4.06573 3.23223C3.59689 3.70107 3.3335 4.33696 3.3335 5V15C3.3335 15.663 3.59689 16.2989 4.06573 16.7678C4.53457 17.2366 5.17045 17.5 5.8335 17.5H14.1668C14.8299 17.5 15.4658 17.2366 15.9346 16.7678C16.4034 16.2989 16.6668 15.663 16.6668 15V5C16.6668 4.33696 16.4034 3.70107 15.9346 3.23223C15.4658 2.76339 14.8299 2.5 14.1668 2.5H5.8335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 5.83337H13.3337V7.50004H6.66699V5.83337Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 9.16663H13.3337V10.8333H6.66699V9.16663Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 12.5H10.8337V14.1667H6.66699V12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocs);
export default __webpack_public_path__ + "static/media/ic-docs.a694c2e45c8e8e607e70a5cf21a99b91.svg";
export { ForwardRef as ReactComponent };